export default __webpack_public_path__ + "static/media/codeclan-graduation-rMAX.6c4423b1.jpg";